import { BreadCrumb } from "primereact/breadcrumb";
import React, { useEffect, useRef, useState } from "react";
import { routes } from "../../../routes";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RoleService from "../../../api/RoleService";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import EmptyMessage from "../../../components/datatable/EmptyMessage";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SearchComponent from "../../../components/datatable/SearchComponent";
import { Toast } from "primereact/toast";
import DeleteConfirmation from "../../../components/modal/DeleteConfirmation";
import { Dialog } from "primereact/dialog";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgressSpinner } from "primereact/progressspinner";
import ActionBtn from "../../../components/dashboard/btn/ActionBtn";
import PermissionService from "../../../api/PermissionService";

const Permission = () => {
  const items = [{ label: "Permissions" }];
  const [refresh, setRefresh] = useState(false);
  const [roles, setRoles] = useState([]);
  const toast = useRef(null);
  const candidate = {
    icon: "pi pi-lock",
    url: routes.dashboard.role.path,
  };
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    //name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const header = () => {
    return (
      <div className="flex justify-content-between">
       
        <SearchComponent
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
        />
      </div>
    );
  };
  useEffect(() => {
    setLoading(true);
    PermissionService.getAll()
      .then((res) => {
        setRoles(res.data.permissions);
        setLoading(false);
      })
      .catch((err) => {});
  }, [refresh]);




  
  return (
    <div className="pl-2 pr-2">
      <Toast ref={toast} />
      
     
        
      <BreadCrumb model={items} home={candidate} />
      <div className="">
        <DataTable
          value={roles}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          dataKey="id"
          filters={filters}
          loading={loading}
          //globalFilterFields={["name"]}
          header={header}
          emptyMessage={EmptyMessage}
        >
          <Column field="name" header="Nom" style={{ width: "50%" }}></Column>
          
        </DataTable>
      </div>
    </div>
  );
};

export default Permission;
